
/** Rounds the number to 3 decimal places. */
export const roundTo3Decimals = (n: number) => Math.round(1000 * n) / 1000
